import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints';

export async function updateForm(formId, body) {
    try {
        return await axios.put(`${LEADS_ENDPOINT}/form/${formId}`, body);
    } catch(error) {
        throw new Error(error);
    }
}
